// Capexara AI — Resources (white papers + expert blogs)
// Index listing (title/excerpt/meta). Full long-form bodies live in
// `./resources-content.js` and are keyed by `id`.
export const RESOURCES = [
  // ─────────────────── WHITE PAPERS ───────────────────
  {
    id: 'wp-01',
    type: 'whitepaper',
    cover: 'steel',
    image: 'https://images.unsplash.com/photo-1518183214770-9cffbec72538?auto=format&fit=crop&w=900&q=70',
    title: 'The ₹200 Lakh Crore Opportunity',
    excerpt: 'A sizing of India\'s capital-project pipeline through 2030, the structural overruns baked in, and where AI-native intervention creates disproportionate returns.',
    author: 'Capexara Research',
    readTime: '22 min',
    date: 'Feb 2026',
  },
  {
    id: 'wp-02',
    type: 'whitepaper',
    cover: 'ember',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=70',
    title: 'The CPCT Blueprint',
    excerpt: 'A reference architecture for the Capital Projects Control Tower: integrating EVM, 4D, claims, HSE, and portfolio rollup into one pane of glass.',
    author: 'Capexara Practice · Controls',
    readTime: '34 min',
    date: 'Jan 2026',
  },
  {
    id: 'wp-03',
    type: 'whitepaper',
    cover: 'dark',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=900&q=70',
    title: 'AWP × Generative AI',
    excerpt: 'How Advanced Work Packaging meets a multi-agent AI — the cognitive backbone behind package-driven execution at scale.',
    author: 'Capexara Practice · Execution',
    readTime: '28 min',
    date: 'Dec 2025',
  },
  {
    id: 'wp-04',
    type: 'whitepaper',
    cover: 'frost',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=900&q=70',
    title: 'EVM is Broken. Here\'s the alternative.',
    excerpt: 'Earned-value has been bent out of shape by ceremony. A cognitive alternative that actually predicts slippage, claims exposure, and recovery paths.',
    author: 'Capexara Practice · Schedule',
    readTime: '26 min',
    date: 'Nov 2025',
  },
  {
    id: 'wp-05',
    type: 'whitepaper',
    cover: 'steel',
    image: 'https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?auto=format&fit=crop&w=900&q=70',
    title: 'Scan-to-IFC: The Five-Day Digital Twin',
    excerpt: 'A repeatable method for converting laser-scan point clouds, legacy drawings, and as-built imagery into a validated, contractor-ready IFC model — in under a week.',
    author: 'Capexara Practice · Design',
    readTime: '30 min',
    date: 'Feb 2026',
  },
  {
    id: 'wp-06',
    type: 'whitepaper',
    cover: 'ember',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=70',
    title: 'Claims Management After GenAI',
    excerpt: 'A 2030 view of claims exposure in FIDIC, NEC, and hybrid-contract regimes — and the workflow redesign that owners, EPCs, and counsel should adopt now.',
    author: 'Capexara Practice · Contracts',
    readTime: '32 min',
    date: 'Jan 2026',
  },
  {
    id: 'wp-07',
    type: 'whitepaper',
    cover: 'dark',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=900&q=70',
    title: 'HSE Telemetry at Scale',
    excerpt: 'From 10,000 daily incidents to one dashboard. A reference architecture for ingesting field HSE telemetry, triaging it, and learning across portfolios.',
    author: 'Capexara Practice · HSE',
    readTime: '24 min',
    date: 'Dec 2025',
  },
  {
    id: 'wp-08',
    type: 'whitepaper',
    cover: 'frost',
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=900&q=70',
    title: 'The Decarbonisation Capex Wall',
    excerpt: 'India\'s net-zero commitment translates to ~₹60 lakh crore of new-build low-carbon capex by 2030. What the owner, the financier, and the regulator each need to solve.',
    author: 'Capexara Research',
    readTime: '28 min',
    date: 'Nov 2025',
  },

  // ─────────────────── BLOGS ───────────────────
  {
    id: 'blog-01',
    type: 'blog',
    cover: 'dark',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=900&q=70',
    title: 'Why megaprojects overrun — and what AI actually changes',
    excerpt: 'Three decades of post-mortem data reveal the same seven root causes. None of them are a scheduling tool problem. All of them are coordination problems.',
    author: 'Aseem R., Founder',
    readTime: '12 min',
    date: 'Feb 2026',
  },
  {
    id: 'blog-02',
    type: 'blog',
    cover: 'steel',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=70',
    title: 'FIDIC clauses your GenAI should refuse to draft',
    excerpt: 'A checklist for contracts teams deploying GenAI in clause drafting — the specific claims patterns where hallucination is most costly.',
    author: 'Capexara Practice · Contracts',
    readTime: '9 min',
    date: 'Jan 2026',
  },
  {
    id: 'blog-03',
    type: 'blog',
    cover: 'ember',
    image: 'https://images.unsplash.com/photo-1503387837-b154d5074bd2?auto=format&fit=crop&w=900&q=70',
    title: 'From P&ID scan to IFC in five days',
    excerpt: 'A real-world walkthrough: 1,200 legacy P&IDs digitised, validated and exported to 3D plant-design suites in under a week using Formigen.',
    author: 'Capexara Practice · Design',
    readTime: '14 min',
    date: 'Dec 2025',
  },
  {
    id: 'blog-04',
    type: 'blog',
    cover: 'frost',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=900&q=70',
    title: 'What CFOs get wrong about digital twins',
    excerpt: 'Most ROI cases for digital twins are built backwards. A cleaner frame: value-per-megawatt, value-per-KL, value-per-MT.',
    author: 'Capexara Practice · CFO Advisory',
    readTime: '11 min',
    date: 'Nov 2025',
  },
  {
    id: 'blog-05',
    type: 'blog',
    cover: 'steel',
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?auto=format&fit=crop&w=900&q=70',
    title: 'Why vendor scheduling platforms still dominate — and how that ends',
    excerpt: 'legacy schedulers and legacy schedulers have held the scheduling throne for two decades because their switching cost is contractual, not technical. That firewall is about to fall.',
    author: 'Aseem R., Founder',
    readTime: '10 min',
    date: 'Feb 2026',
  },
  {
    id: 'blog-06',
    type: 'blog',
    cover: 'ember',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=900&q=70',
    title: 'The seven RFIs that eat your float',
    excerpt: 'A taxonomy of recurring RFIs in EPC execution — and the surprisingly simple pattern that lets you price them into the baseline.',
    author: 'Capexara Practice · Execution',
    readTime: '8 min',
    date: 'Jan 2026',
  },
  {
    id: 'blog-07',
    type: 'blog',
    cover: 'dark',
    image: 'https://images.unsplash.com/photo-1542626991-cbc4e32524cc?auto=format&fit=crop&w=900&q=70',
    title: 'What a 4D schedule actually costs to maintain',
    excerpt: 'The honest number is not in any vendor brochure. Here it is, decomposed line by line — and the software model that reduces it by 80%.',
    author: 'Capexara Practice · Schedule',
    readTime: '9 min',
    date: 'Dec 2025',
  },
  {
    id: 'blog-08',
    type: 'blog',
    cover: 'frost',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=900&q=70',
    title: 'How to read a FIDIC Red Clause 20.1 notice',
    excerpt: 'The 28-day time-bar is the single most consequential clause in the Red Book. A plain-English guide to what a notice actually must contain, and what usually goes missing.',
    author: 'Capexara Practice · Contracts',
    readTime: '7 min',
    date: 'Dec 2025',
  },
  {
    id: 'blog-09',
    type: 'blog',
    cover: 'steel',
    image: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=900&q=70',
    title: 'The ROI case CFOs never see — commissioning defect rate',
    excerpt: 'One number you can measure, track and cut by a factor of four. It is worth more than every other control-tower metric combined.',
    author: 'Capexara Practice · CFO Advisory',
    readTime: '9 min',
    date: 'Nov 2025',
  },
  {
    id: 'blog-10',
    type: 'blog',
    cover: 'ember',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=900&q=70',
    title: 'Why "platform + agents" is the only defensible pattern in EPC SaaS',
    excerpt: 'Point solutions are already commoditised. Platforms without agents degrade into dashboards. The durable pattern for EPC SaaS in 2026 is both.',
    author: 'Aseem R., Founder',
    readTime: '11 min',
    date: 'Nov 2025',
  },
];
